export default {"src":"/_next/static/media/two-users-outline.156d5aa4.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};